import React from 'react'
import imgtop1 from './images/about us-02.png'

export default function WeAreDiffrent() {
  return (
    <>
      <div className="container aboutsection-main">
      <div className="row row-col-2 AboutMain">
        <div className="col rightSide">
          <div className="rightSideContain">
            <div className="rightHead">
              <h2>Your Digital Growth Partner
              </h2>
            </div> 
            <div className="rightDesc">
              <p>Raj Digital Marketing is a fast-growing, results-driven digital marketing agency based in Pune, India. We specialize in building powerful online identities and transforming brands through a mix of strategy, creativity, and technology.With a strong focus on SEO, performance marketing, social media, and web development, our team blends data-driven insights with purpose-led creativity to deliver meaningful digital experiences.</p>
            </div>
          </div>
        </div>
        <div className="col leftSide">
        <img src={imgtop1} alt="" />
    </div> 
    </div>
    </div> 
    </>
  )
}
